import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons/faPlus";
import { faMinus } from "@fortawesome/free-solid-svg-icons/faMinus";
import { getBrowser } from "../../utils/browserUtils";

export default function CardExpanding(props) {
  const {
    header,
    content,
    cardStyle,
    headerStyle,
    contentStyle,
    useIcon,
  } = props;

  const [openState, setOpenState] = useState(false);

  function getContent() {
    const animStyle = {
      overflow: "hidden",
      transition: "max-height 0.3s ease-out",
      maxHeight: "0px",
    };

    if (openState) {
      const browser = getBrowser();
      console.log("browser is", browser);

      animStyle.maxHeight = "500px";
    }

    if (Array.isArray(content)) {
      return (
        <div className={contentStyle} style={animStyle}>
          {parseStringArray(content)}
        </div>
      );
    }

    return (
      <>
        <p className={contentStyle} style={animStyle}>
          {content}
          {/* {contentType === "royaltyFree" ? (
            <a
              style={{ cursor: "pointer" }}
              href="https://www.buildbox.com/rev-share-details"
            >
              <span>here</span>
            </a>
          ) : (
            ""
          )} */}
        </p>
      </>
    );
  }

  function parseStringArray(stringArray) {
    // eslint-disable-next-line
    return stringArray.map((item, i) => {
      if (Array.isArray(item)) {
        return (
          <div key={"_cardStringArrayContainer_" + item[0]}>
            {parseStringArray(item)}
          </div>
        );
      } else if (item !== "\n") {
        let osStyle = {};
        if (item === "Mac OS" || item === "Windows PC") {
          osStyle = {
            'font-weight': "700",
            'margin-top': "1rem",
          };
        }

        return <p style={osStyle} key={"_cardStringLine_" + item + i}>{item}</p>;
      }
    });
  }

  return (
    <div className={cardStyle}>
      <div
        className={headerStyle}
        onClick={() => {
          setOpenState(!openState);
        }}
      >
        {header}
        {useIcon && <FontAwesomeIcon icon={openState ? faMinus : faPlus} />}
      </div>
      {getContent()}
    </div>
  );
}
